var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion component --dark" }, [
    _c(
      "ul",
      {
        staticClass: "accordion-wrapper container",
        attrs: { "aria-label": "Accordion" },
      },
      [
        _vm.tabs.length > 0
          ? _vm._l(_vm.tabs, function (tab, index) {
              return _c("accordion-tab", {
                key: index,
                on: {
                  tabToggled: function ($event) {
                    return _vm.handleTabToggled(index)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var expanded = ref.expanded
                        return _c(
                          "li",
                          {
                            staticClass: "accordion-item",
                            attrs: {
                              id: "accordion-item-" + (index + 1),
                              "data-component":
                                index === 0 ? "your-trip" : "arrival-details",
                            },
                          },
                          [
                            _c("div", { staticClass: "accordion-item-panel" }, [
                              _c(
                                "div",
                                { staticClass: "accordion-item-panel-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "accordion-item-text" },
                                    [
                                      _c(
                                        "h4",
                                        { staticClass: "accordion-item-title" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(tab.accordionTitle) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "accordion-item-description",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(tab.accordionDescription)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "accordion-item-panel-filler",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      class: expanded ? "expanded" : "",
                                      attrs: {
                                        id: "accordion-control-" + index,
                                        "aria-controls": "content-" + index,
                                        "aria-expanded": expanded
                                          ? "true"
                                          : "false",
                                        "aria-label":
                                          tab.accordionTitle +
                                          " " +
                                          (expanded
                                            ? _vm.closeLabel
                                            : _vm.openLabel),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleInteraction(index)
                                        },
                                        enter: function ($event) {
                                          return _vm.handleInteraction(index)
                                        },
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.handleInteraction(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            expanded
                                              ? _vm.closeLabel
                                              : _vm.openLabel
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            expanded
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "accordion-item-content",
                                    attrs: {
                                      id: "content-" + index,
                                      "aria-hidden": expanded
                                        ? "false"
                                        : "true",
                                    },
                                  },
                                  [_vm._t("tab" + (index + 1))],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }